import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

/** `Home / {series}` on the page, `Home / {series} / {page}` below it. */
const SeriesBreadcrumb: React.FC<{
  displayTitle: string;
  series: string;
  page?: string;
}> = ({ displayTitle, series, page }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumb className="border-neutral-60 hidden border-b pb-4 sm:block">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/">{t("series_details_breadcrumb_home_label_web")}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          {page ? (
            <BreadcrumbLink asChild>
              <Link to="/series/$series" params={{ series }}>
                {displayTitle}
              </Link>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage>{displayTitle}</BreadcrumbPage>
          )}
        </BreadcrumbItem>
        {page && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{page}</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default SeriesBreadcrumb;
